"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ANGSearch = _interopRequireDefault(require("@mulesoft/ang-search-component/lib/search/ANGSearch"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _exchangeSearchCommon = require("@mulesoft/exchange-search-common");
var _hooks = require("../../hooks");
var _utils = require("./utils");
var _hooks2 = require("./hooks");
var _CustomFieldsFilter = _interopRequireDefault(require("./CustomFieldsFilter"));
var _Loading = _interopRequireDefault(require("./Loading"));
var _FiltersToggle = _interopRequireDefault(require("./FiltersToggle"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles = {
  "search": "search_HZgNEY",
  "with-filters-toggle": "with-filters-toggle_TuScSR",
  "withFiltersToggle": "with-filters-toggle_TuScSR",
  "no-filters": "no-filters_vf4p-T",
  "noFilters": "no-filters_vf4p-T"
}; 
require('./Search.css');
const SEARCH_EXECUTED = 'Search executed';
const getStatusText = status => status === 'published' ? 'stable' : status;
const getPlaceholderText = (placeholder, type, status) => {
  if (placeholder) {
    return placeholder;
  }
  let placeholderText = 'Search ';
  if (status === 'development') {
    return `${placeholderText}${type !== null && type !== void 0 ? type : 'assets'} in development`;
  }
  if (status) {
    placeholderText = `${placeholderText}${getStatusText(status)} `;
  }
  return `${placeholderText}${type !== null && type !== void 0 ? type : 'assets'}`;
};
const toLowerCase = value => {
  // is this an acronym?
  if (value.length > 1 && [...value.substring(0, 2)].every(char => char.toUpperCase() === char)) {
    return value;
  }
  return `${value.charAt(0).toLowerCase()}${value.slice(1)}`;
};
const Search = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  var _assetTypesConfigurat;
  const {
    statuses: fixedStatuses,
    types: fixedTypes,
    filters: searchFilters,
    showFiltersToggle: showFiltersToggleProp,
    showFiltersDefault,
    maxResults,
    organizationId,
    onReady,
    boostConfiguration
  } = props;
  const isControlledComponent = !!props.angFilters;
  const assetTypesConfiguration = (0, _exchangeReactHooks.useAssetTypesConfiguration)();
  const trackEvent = (0, _exchangeReactHooks.useAnalyticsTracking)();
  const featureFlags = (0, _exchangeReactHooks.useFeatureFlags)();
  const options = _react.default.useMemo(() => ({
    fixedTypes,
    fixedStatuses
  }), [fixedTypes.join(','), fixedStatuses.join(',')]);
  const defaultANGFilters = _react.default.useMemo(() => props.defaultANGFilters ? new _exchangeSearchCommon.ANGFilters(props.defaultANGFilters, assetTypesConfiguration, options) : null, [props.defaultANGFilters, assetTypesConfiguration, options]);
  let filters;
  let setFilters;
  const lastFiltersExecutedRef = _react.default.useRef({
    angFilters: props.angFilters,
    sort: props.sort
  });
  if (isControlledComponent) {
    filters = props.angFilters;
    setFilters = (angFilters, sort) => {
      if (props.onFiltersChange) {
        props.onFiltersChange(angFilters, sort);
      }
      lastFiltersExecutedRef.current = {
        angFilters,
        sort
      };
    };
  } else {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    [filters, setFilters] = _react.default.useState(defaultANGFilters !== null && defaultANGFilters !== void 0 ? defaultANGFilters : _exchangeSearchCommon.ANGFilters.createEmptyState(assetTypesConfiguration, options));
  }
  const defaultState = filters.getAsANGState();
  const query = filters.getAsANGQuery();
  const showTypes = (fixedTypes === null || fixedTypes === void 0 ? void 0 : fixedTypes.length) !== 1;
  const status = (fixedStatuses === null || fixedStatuses === void 0 ? void 0 : fixedStatuses.length) === 1 ? fixedStatuses[0] : null;
  const type = (fixedTypes === null || fixedTypes === void 0 ? void 0 : fixedTypes.length) === 1 ? toLowerCase((_assetTypesConfigurat = assetTypesConfiguration[fixedTypes[0]]) === null || _assetTypesConfigurat === void 0 ? void 0 : _assetTypesConfigurat.filter) : null;
  const showFiltersToggle = showFiltersToggleProp && (searchFilters === null || searchFilters === void 0 ? void 0 : searchFilters.length) > 0;
  const [angState, setANGState] = _react.default.useState(defaultState);
  const tryFn = (0, _exchangeReactHooks.useTryFn)();
  const [results, setResults] = (0, _hooks.useSearchResults)();
  const resultsRef = _react.default.useRef();
  const isReadyRef = _react.default.useRef(false);
  resultsRef.current = results;
  const handleReady = _react.default.useCallback(() => {
    if (!isReadyRef.current) {
      isReadyRef.current = true;
      onReady === null || onReady === void 0 || onReady();
    }
  }, []);
  const [showFilters, setShowFilters] = _react.default.useState(showFiltersToggle ? showFiltersDefault : !!(searchFilters !== null && searchFilters !== void 0 && searchFilters.length));
  const [facets, setFacets] = (0, _hooks2.useFacets)(query, searchFilters, organizationId, fixedTypes, handleReady);
  const updateFilter = (0, _hooks2.useUpdateFilter)(query, setFacets, organizationId, fixedTypes);
  const getANGConfig = (0, _hooks2.useGetANGConfig)({
    maxResults,
    fixedTypes,
    fixedStatuses,
    facets,
    searchFilters,
    angQuery: query,
    updateFilter,
    boostConfiguration
  });
  const handleResultsChange = newResults => {
    var _props$onResultsChang;
    setResults(newResults);
    (_props$onResultsChang = props.onResultsChange) === null || _props$onResultsChang === void 0 || _props$onResultsChang.call(props, newResults);
  };
  const handleValueChange = _react.default.useCallback($angState => {
    setANGState($angState);
  }, []);
  const handleBatchProcess = (batch, batchNumber) => {
    const newResults = batch.reduce((accum, [asset, highlight]) => (0, _utils.buildAssetsList)({
      results: accum,
      asset,
      highlight,
      batchNumber
    }), resultsRef.current.results);
    handleResultsChange({
      results: newResults,
      currentBatch: batch,
      hasExecutedQuery: true,
      showTypes,
      statuses: fixedStatuses,
      isLoading: true
    });
  };
  const handleSearch = _react.default.useCallback(($angConfig, $angState, $angFilters, sort) => {
    var _lastFiltersExecutedR, _newFilters;
    let newFilters = $angFilters;
    if (!newFilters) {
      newFilters = _exchangeSearchCommon.ANGFilters.buildFromANGState($angState, assetTypesConfiguration, options);
    }

    // this compares current search with previous search, if user is adding "search" term, then
    // do the following search sorting by "score" instead of using the previous set sort option
    const isChangingSearchTerm = !((_lastFiltersExecutedR = lastFiltersExecutedRef.current.angFilters) !== null && _lastFiltersExecutedR !== void 0 && _lastFiltersExecutedR.getQuery().search) && !!((_newFilters = newFilters) !== null && _newFilters !== void 0 && _newFilters.getQuery().search);
    const newSort = sort !== null && sort !== void 0 ? sort : isChangingSearchTerm ? 'score' : props.sort;
    if (!$angFilters) {
      setFilters(newFilters, newSort);
    } else {
      lastFiltersExecutedRef.current = {
        angFilters: $angFilters,
        sort: newSort
      };
    }
    const angConfig = getANGConfig(newSort);
    if (props.onSearch) {
      const searchResult = props.onSearch(newFilters, $angState, angConfig, newSort);

      // this is a pattern taken from the Facebook team, if the event is marked as "handled",
      // then it means that no default behavior should be executed. It works similar to `event.preventDefault()`
      if (searchResult === 'handled') {
        return;
      }
    }
    handleResultsChange({
      isLoading: true,
      hasExecutedQuery: true,
      showTypes,
      statuses: fixedStatuses,
      results: []
    });
    tryFn(async $context => {
      await (0, _utils.executeSearch)({
        angConfig,
        angState: _objectSpread(_objectSpread({}, $angState), {}, {
          customFilters: (0, _utils.processCustomFilters)($angState, facets)
        }),
        assetTypesConfiguration,
        authorization: $context.authorization,
        featureFlags,
        fixedTypes,
        onBatchProcess: handleBatchProcess,
        onFinish: () => {
          const assets = resultsRef.current.results;
          handleResultsChange({
            isLoading: false,
            hasExecutedQuery: true,
            showTypes,
            statuses: fixedStatuses,
            results: assets
          });
          const analyticsInfo = (0, _utils.getAnalyticsInfo)(assets);
          trackEvent(SEARCH_EXECUTED, _objectSpread({
            query: (0, _utils.getSearchQueryAnalytics)(newFilters, facets),
            resultCount: assets.length,
            context: {
              searchExperience: 'ang'
            }
          }, analyticsInfo));
        }
      });
    });
  }, [props.onSearch, filters, facets, getANGConfig, props.sort]);
  _react.default.useEffect(() => {
    var _lastFiltersExecutedR2, _lastFiltersExecutedR3;
    if (!props.angFilters) {
      return;
    }
    const didFiltersChange = ((_lastFiltersExecutedR2 = lastFiltersExecutedRef.current) === null || _lastFiltersExecutedR2 === void 0 ? void 0 : _lastFiltersExecutedR2.angFilters) && !_exchangeSearchCommon.ANGFilters.compare(props.angFilters, lastFiltersExecutedRef.current.angFilters);
    const didSortChange = props.sort && props.sort !== ((_lastFiltersExecutedR3 = lastFiltersExecutedRef.current) === null || _lastFiltersExecutedR3 === void 0 ? void 0 : _lastFiltersExecutedR3.sort);

    // check if one of filters or sort condition changed, if so then execute the search
    if (didFiltersChange || didSortChange) {
      const newANGState = props.angFilters.getAsANGState();
      const angConfig = getANGConfig(props.sort);
      setANGState(newANGState);
      handleSearch(angConfig, newANGState, props.angFilters, props.sort);
    }
  }, [props.angFilters, props.sort, getANGConfig]);
  const clearFilters = _react.default.useCallback(() => {
    const clearedFilters = _exchangeSearchCommon.ANGFilters.buildFromANGState({
      query: angState === null || angState === void 0 ? void 0 : angState.query,
      filters: {},
      customFilters: {}
    }, assetTypesConfiguration, options);
    const angConfig = getANGConfig(props.sortOnClear);
    setFilters(clearedFilters, props.sortOnClear);
    setANGState(clearedFilters.getAsANGState());
    handleSearch(angConfig, clearedFilters.getAsANGState(), null, props.sortOnClear);
  }, [getANGConfig, angState === null || angState === void 0 ? void 0 : angState.query, props.sort]);
  const handleToggleFilters = _react.default.useCallback(value => {
    if (!value) {
      clearFilters();
    }
    setShowFilters(value);
  }, [clearFilters]);
  _react.default.useImperativeHandle(ref, () => ({
    search: () => {
      const angConfig = getANGConfig(props.sort);
      handleSearch(angConfig, angState);
    }
  }), [getANGConfig, props.sort, angState]);
  const noFilters = !showFilters || !searchFilters || searchFilters.length === 0;
  const isLoadingFacets = (searchFilters === null || searchFilters === void 0 ? void 0 : searchFilters.length) > 0 && !facets;
  const customFilters = _react.default.useMemo(() => {
    if (isLoadingFacets) {
      return {
        Loading: _Loading.default
      };
    }
    return {
      CustomFieldsFilter: _CustomFieldsFilter.default
    };
  }, [isLoadingFacets]);
  const facetsContext = _react.default.useMemo(() => ({
    facets,
    filters: searchFilters
  }), [facets, searchFilters]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(styles.search, {
      [styles.noFilters]: noFilters,
      [styles.withFiltersToggle]: showFiltersToggle
    })
  }, /*#__PURE__*/_react.default.createElement(_hooks2.FacetsContext.Provider, {
    value: facetsContext
  }, /*#__PURE__*/_react.default.createElement(_ANGSearch.default, {
    config: getANGConfig(props.sort),
    value: angState,
    executor: handleSearch,
    onValueChange: handleValueChange,
    placeholder: getPlaceholderText(props.placeholder, type, status),
    customFilters: customFilters
  })), showFiltersToggle ? /*#__PURE__*/_react.default.createElement(_FiltersToggle.default, {
    onChange: handleToggleFilters,
    showFilters: showFilters
  }) : null);
});
Search.defaultProps = {
  types: [],
  statuses: [],
  showFiltersToggle: false,
  showFiltersDefault: false
};
var _default = exports.default = Search;
//# sourceMappingURL=Search.js.map